'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createConstants;

var _ramda = require('ramda');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createConstants(namespace, constants) {
  return (0, _ramda.reduce)(function (memo, constantKey) {
    return (0, _ramda.merge)(memo, _defineProperty({}, constantKey, (0, _ramda.toUpper)(namespace + '_' + constantKey)));
  }, {}, (0, _ramda.keys)(constants));
}